// extracted by mini-css-extract-plugin
export default {"table":"style_table__wkV-m","fadeIn":"style_fadeIn__SrZlZ","noOverflow":"style_noOverflow__nG7t2"};